import { useEffect, useRef, useState } from "react";
import { messages } from "../i18n/index.ts";

interface DuelClockProps {
  remainingMs: number;
  /**
   * Süreyi kısaltan kural yalnızca düelloda var (rakip bulunca 30 sn'ye iner).
   * 2v2'de bitiş anı maç boyunca sabit; orada bu tespit yalnızca yanlış alarm
   * üretiyordu: sekme arka plana atılıp timer'lar kısılınca ya da sunucu saat
   * farkı yeniden ölçülünce sayaç iki ölçüm arasında 2 sn'den fazla düşüyor.
   */
  canShorten?: boolean;
}

function format(ms: number): string {
  const total = Math.ceil(ms / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/** Normal akışta saniyede ~1 sn düşer; bundan büyük düşüş kural kaynaklıdır. */
const JUMP_THRESHOLD_MS = 2000;

export function DuelClock({ remainingMs, canShorten = true }: DuelClockProps) {
  // Son 30 saniyede alev rengi + nabız; kalan zamanı sözcük olmadan anlatıyor.
  const urgent = remainingMs <= 30_000;

  /*
   * Rakip kelimeyi bulunca süre 30 saniyeye iner. Saatin sessizce zıplaması
   * kaçırılır; kısa bir çakma bunu görünür kılıyor.
   */
  const previous = useRef(remainingMs);
  const [cut, setCut] = useState(false);

  useEffect(() => {
    const dropped = previous.current - remainingMs;
    previous.current = remainingMs;
    if (!canShorten || dropped < JUMP_THRESHOLD_MS) return;

    setCut(true);
    const id = window.setTimeout(() => setCut(false), 1200);
    return () => window.clearTimeout(id);
  }, [canShorten, remainingMs]);

  return (
    <div
      className="duel-clock"
      data-urgent={urgent ? "true" : undefined}
      data-cut={cut ? "true" : undefined}
      role="timer"
      aria-live="off"
    >
      <span className="duel-clock__value">{format(remainingMs)}</span>
      <span className="duel-clock__label">
        {cut ? messages.clock.shortened : messages.clock.remaining}
      </span>
    </div>
  );
}
